import { render } from "./KioskSpotRegistrationListView.vue?vue&type=template&id=fc66683e"
import script from "./KioskSpotRegistrationListView.vue?vue&type=script&lang=js"
export * from "./KioskSpotRegistrationListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__